<template>
    <div class="container-message-manager">
        <span ref="messageArea" class="message-input" role="textbox" @input="event => onInput(event)" contenteditable></span>
        <div class="container-send-message icon-send-message" @click.prevent="sendMessage">
            <SendIcon size="25" :fill-color="colors.submitIcon"/>
        </div>
    </div>
</template>

<script>
    //import 'vue-material-design-icons/styles.css';
    // import {mapMutations} from 'vuex'
    import SendIcon from 'vue-material-design-icons/Send';
    export default {
        components: {
            SendIcon
        },
        props: {
            colors: {
                type: Object,
                required: true
            },
            myself: {
                type: Object, 
                required: true
            }
        },
        data() {
            return {
                textInput: null,
                timer: null,
            }
        },
        mounted() {
            this.$refs.messageArea.focus()
        },
        methods: {
            // ...mapMutations([
            //     'newMessage'
            // ]),
            focusInput() {
                this.$refs.messageArea.focus();
            },
            onInput(event) {
                this.startTimer();
                this.textInput = event.target.innerText;
            },
            startTimer() {
                if (this.timer) { clearTimeout(this.timer) }
                else { this.$emit('onTyping', true) }

                this.timer = setTimeout(function () { this.stopTyping() }.bind(this), 15000)
            },
            stopTyping() {
                this.timer = null
                this.$emit('onTyping', false)
            },
            sendMessage() {
                try {
                    // match characters that are different of spaces, tabs, line breaks...
                    const matchNotEmpty = /[^\s]+/i
                    // match characters that are between line spaces, tabs, line breaks...
                    const contentMatch = this.textInput.match(/^\s*((.|\n)+?)\s*$/i)
                    if (this.textInput && matchNotEmpty.test(this.textInput) && contentMatch) {
                        var today = new Date();
                        var dateTime = today.toLocaleDateString()+' '+today.toLocaleTimeString()

                        let message = {
                            content: contentMatch[1],
                            // myself: true,
                            participantId: this.myself.id,
                            timestamp: dateTime,
                            uploaded: false,
                            viewed: false,
                            type: 'text'
                        };
                        // console.log('submitting message: ', message)
                        this.$emit("onMessageSubmit", message)
                        this.stopTyping()
                        //this.onMessageSubmit(message)
                        // this.newMessage(message)
                        this.$refs.messageArea.innerText = "";
                    }
                } catch (e) {
                    console.log('send message error: ', e)
                }
                
            }
        }
    }
</script>